const Sentry = require("@sentry/nextjs");
const { JOB_SOURCE_ASHBY } = require("../../../components/pages/careers/careers-constants");
const { getDeptIDFromPosition, getLocationIDFromPosition } = require("../../../components/pages/careers/careers-service");
const getLocationString = (position)=>{
    var _position_location;
    return typeof position.location === "string" ? position.location : ((_position_location = position.location) === null || _position_location === void 0 ? void 0 : _position_location.name) || "";
};
const buildPositionKey = (position)=>{
    const title = (position.name || "").toLowerCase().trim();
    const department = (position.department || "").toLowerCase().trim();
    const location = getLocationString(position).toLowerCase().trim();
    return `${title}|${department}|${location}`;
};
const PREFER_ASHBY_DEPARTMENTS = [
    "consulting",
    "partnership"
];
const PREFER_ASHBY_LOCATIONS = [
    "london",
    "munich",
    "paris",
    "remote-emea"
];
const PREFER_ASHBY_SPECIAL = [
    {
        department: "rnd",
        location: "london"
    }
];
const shouldPreferAshby = (position)=>{
    const dept = getDeptIDFromPosition(position);
    const loc = getLocationIDFromPosition(position);
    if (!dept || !loc) return false;
    if (PREFER_ASHBY_SPECIAL.some((s)=>s.department === dept && s.location === loc)) return true;
    return PREFER_ASHBY_DEPARTMENTS.includes(dept) && PREFER_ASHBY_LOCATIONS.includes(loc);
};
const logDuplicate = (position, key, keptSource)=>{
    Sentry.captureMessage("Duplicate position resolved", {
        level: "warning",
        extra: {
            id: position.uid,
            title: position.name,
            department: position.department,
            location: getLocationString(position),
            duplicateKey: key,
            keptSource
        }
    });
};
const mergeAndDeduplicate = (comeetPositions, ashbyPositions)=>{
    const positionsByKey = new Map();
    for (const position of comeetPositions){
        positionsByKey.set(buildPositionKey(position), position);
    }
    for (const ashbyPosition of ashbyPositions){
        const key = buildPositionKey(ashbyPosition);
        const existing = positionsByKey.get(key);
        if (!existing) {
            positionsByKey.set(key, ashbyPosition);
        } else if (existing.source !== JOB_SOURCE_ASHBY && shouldPreferAshby(ashbyPosition)) {
            positionsByKey.set(key, ashbyPosition);
            logDuplicate(ashbyPosition, key, JOB_SOURCE_ASHBY);
        }
    }
    return Array.from(positionsByKey.values());
};
module.exports = {
    mergeAndDeduplicate
};
